import BaseModule from './base-module';

// 文案
class Article extends BaseModule {
  // 新增文案
  AddCopywriting(params) {
    return this.post('/admin/i_lis_copywriting/add', params);
  }

  // 文案列表
  CopywritingList(params) {
    return this.post('/admin/i_lis_copywriting/list', params);
  }

  // 是否发布
  CopywritingPublish(params) {
    return this.post('/admin/i_lis_copywriting/publish', params);
  }

  // 删除文案
  CopywritingDelete(params) {
    return this.post('/admin/i_lis_copywriting/delete', params);
  }

  // 修改文案
  Copywritingupdate(params) {
    return this.post('/admin/i_lis_copywriting/update', params);
  }

  //排序
  Copywritingorder(params) {
    return this.post('/admin/i_lis_copywriting/order', params);
  }

}

export default new Article();
